export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

export const FETCH_CUSTOMERS_REQUEST = 'FETCH_CUSTOMERS_REQUEST';
export const FETCH_CUSTOMERS_SUCCESS = 'FETCH_CUSTOMERS_SUCCESS';
export const FETCH_CUSTOMERS_FAILURE = 'FETCH_CUSTOMERS_FAILURE';

export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';

export const UPDATE_USERS_REQUEST = 'UPDATE_USERS_REQUEST';
export const UPDATE_USERS_SUCCESS = 'UPDATE_USERS_SUCCESS';
export const UPDATE_USERS_FAILURE = 'UPDATE_USERS_FAILURE';

export const UPDATE_PWD_REQUEST = 'UPDATE_PWD_REQUEST';
export const UPDATE_PWD_SUCCESS = 'UPDATE_PWD_SUCCESS';
export const UPDATE_PWD_FAILURE = 'UPDATE_PWD_FAILURE';

export const DELETE_USERS_REQUEST = 'DELETE_USERS_REQUEST';
export const DELETE_USERS_SUCCESS = 'DELETE_USERS_SUCCESS';
export const DELETE_USERS_FAILURE = 'DELETE_USERS_FAILURE';

export const OPEN_EDIT_PAGE = 'OPEN_EDIT_PAGE';
export const OPEN_EDIT_PAGE_SUCCESS = 'OPEN_EDIT_PAGE_SUCCESS';

export const KPI_USERS_REQUEST = 'KPI_USERS_REQUEST';
export const KPI_USERS_SUCCESS = 'KPI_USERS_SUCCESS';
export const KPI_USERS_FAILURE = 'KPI_USERS_FAILURE';

export const KPI_CUSTOMERS_REQUEST = 'KPI_CUSTOMERS_REQUEST';
export const KPI_CUSTOMERS_SUCCESS = 'KPI_CUSTOMERS_SUCCESS';
export const KPI_CUSTOMERS_FAILURE = 'KPI_CUSTOMERS_FAILURE';

export const REQUEST_PASSWORD_RESET = 'REQUEST_PASSWORD_RESET';
export const REQUEST_PASSWORD_RESET_SUCCESS = 'REQUEST_PASSWORD_RESET_SUCCESS';
export const REQUEST_PASSWORD_RESET_FAILURE = 'REQUEST_PASSWORD_RESET_FAILURE';

export const VALIDATE_PASSWORD_TOKEN = 'VALIDATE_PASSWORD_TOKEN';
export const VALIDATE_PASSWORD_TOKEN_SUCCESS = 'VALIDATE_PASSWORD_TOKEN_SUCCESS';
export const VALIDATE_PASSWORD_TOKEN_FAILURE = 'VALIDATE_PASSWORD_TOKEN_FAILURE';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const REGISTER_USER_REQUEST = 'REGISTER_USER_REQUEST';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILURE = 'REGISTER_USER_FAILURE';

export const ACTIVATE_ACCOUNT_REQUEST = 'ACTIVATE_ACCOUNT_REQUEST';
export const ACTIVATE_ACCOUNT_SUCCESS = 'ACTIVATE_ACCOUNT_SUCCESS';
export const ACTIVATE_ACCOUNT_FAILURE = 'ACTIVATE_ACCOUNT_FAILURE';

export const VERIFY_USER_REQUEST = 'VERIFY_USER_REQUEST';
export const VERIFY_USER_SUCCESS = 'VERIFY_USER_SUCCESS';
export const VERIFY_USER_FAILURE = 'VERIFY_USER_FAILURE';

export const ACTIVATE_USER_REQUEST = 'ACTIVATE_USER_REQUEST';
export const ACTIVATE_USER_SUCCESS = 'ACTIVATE_USER_SUCCESS';
export const ACTIVATE_USER_FAILURE = 'ACTIVATE_USER_FAILURE';

export const BAN_USER_REQUEST = 'BAN_USER_REQUEST';
export const BAN_USER_SUCCESS = 'BAN_USER_SUCCESS';
export const BAN_USER_FAILURE = 'BAN_USER_FAILURE';

export const RESEND_ACTIVATION_EMAIL_REQUEST = 'RESEND_ACTIVATION_EMAIL_REQUEST';
export const RESEND_ACTIVATION_EMAIL_SUCCESS = 'RESEND_ACTIVATION_EMAIL_SUCCESS';
export const RESEND_ACTIVATION_EMAIL_FAILURE = 'RESEND_ACTIVATION_EMAIL_FAILURE';

export const SEND_EMAIL_ADMIN_REQUEST = 'SEND_EMAIL_ADMIN_REQUEST';
export const SEND_EMAIL_ADMIN_SUCCESS = 'SEND_EMAIL_ADMIN_SUCCESS';
export const SEND_EMAIL_ADMIN_FAILURE = 'SEND_EMAIL_ADMIN_FAILURE';

export const CLEAR_USER_ERRORS = 'CLEAR_USER_ERRORS';
export const CLEAR_USER_SUCCESS = 'CLEAR_USER_SUCCESS';